import Chat from './Chat';

export default class Dm extends Chat {
  partner;

  type = 'dm';
}
